import dom from '../../wrapper/DomWrapper';

export const scrollTop = (offset) => {
  dom.window.scrollTo(0, offset);
};

export const easeInOutCubic = (t, b, c, d) => {
  // eslint-disable-next-line no-param-reassign
  const ts = (t /= d) * t;
  const tc = ts * t;

  return b + c * (-2 * tc + 3 * ts);
};

export const cancelAnimFrame = (() => (
  dom.window.cancelAnimationFrame
  || dom.window.webkitCancelRequestAnimationFrame
  || dom.window.mozCancelRequestAnimationFrame
  || dom.window.oCancelRequestAnimationFrame
  || dom.window.msCancelRequestAnimationFrame
  || clearTimeout
).bind(dom.window))();

// eslint-disable-next-line func-names
export const requestAnimFrame = (function () {
  return (
    dom.window.requestAnimationFrame
    || dom.window.webkitRequestAnimationFrame
    || dom.window.mozRequestAnimationFrame
    || dom.window.oRequestAnimationFrame
    || dom.window.msRequestAnimationFrame
    // eslint-disable-next-line func-names
    || function (callback) {
      dom.window.setTimeout(callback, 1000 / 60);
    }
  );
}());
